var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "myskov-saved-offers" },
    [
      !_vm.loading && !_vm.hotelBlocks.length && !_vm.error
        ? _c("msg-block", [
            _c("p", [
              _c("b", {
                domProps: { textContent: _vm._s(_vm.translations.no_offers) }
              })
            ]),
            _vm._v(" "),
            _c("p", [
              _c("a", {
                attrs: { href: "/" },
                domProps: {
                  textContent: _vm._s(_vm.translations.no_offers_ctr)
                }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c("msg-block", { attrs: { type: "error" } }, [
            _c("p", [_c("b", { domProps: { textContent: _vm._s(_vm.error) } })])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c("msg-block", [
            _c("p", [
              _c("b", {
                domProps: { textContent: _vm._s(_vm.translations.loading) }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "hotel-grid" },
        _vm._l(_vm.hotelBlocks, function(hotelBlock, hotelKey) {
          return _c("hotel-block", {
            key: hotelBlock.id,
            attrs: { hotel: hotelBlock, "is-favorite-item": true }
          })
        })
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3683c37a", { render: render, staticRenderFns: staticRenderFns })
  }
}